document.addEventListener('DOMContentLoaded', e => {
    var header = document.querySelector('.header');
    var megamenu = header.querySelector('.mega-menu');
    var annocements = document.querySelector('.announcement-bar');

    if (annocements) {
        console.log(annocements.offsetHeight);
        header.style.marginTop = annocements.offsetHeight + 'px';
    }
    if (header.classList.contains('overlay')) {
        header.classList.add('overlay-on');
        megamenu.addEventListener('mouseover', e => {
            header.classList.remove('overlay-on');
        })
        megamenu.addEventListener('mouseleave', e => {
            header.classList.add('overlay-on');
        })
    }

    if (header.classList.contains('standard-white')) {
        console.log('?');
        megamenu.addEventListener('mouseover', e => {
            header.classList.add('standard-white-on');
        })
        megamenu.addEventListener('mouseleave', e => {
            header.classList.remove('standard-white-on');
        })
    }


   GeoAPI();
})

const GeoAPI = () => {
    fetch('https://api.ipbase.com/v2/info?apikey=ipb_live_DOEuTWOEMeZS4CRpjh4ejjRy6FiJM75VNgYl97ko')
        .then(response => response.json())
        .then(data => {
            let country = data.data.location.country.alpha2;
            console.log(country);
            updateFreeShippingBar(country);
        })
        .catch(error => {
            console.error('Error fetching geolocation data:', error);
        });

    function updateFreeShippingBar(country) {
        let announcementValue = document.querySelector('.announcement-bar .announcement-bar__message span');
        const countries = ['DE', 'AT', 'FR', 'IT', 'NL', 'BE', 'DK', 'MC', 'PL', 'CZ', 'SE', 'ES', 'HU', 'IE', 'LU', 'GB'];
        const otherCountries = ['FI','NO','PT']
        if (!announcementValue) return;

        if (countries.includes(country)) {
            announcementValue.innerText = 'FREE SHIPPING FOR ORDERS OVER €100!';
          } else if (otherCountries.includes(country)) {
            announcementValue.innerText = 'FREE SHIPPING FOR ORDERS OVER €150!';
          }
    }

}